import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { createMassTraderDiariesAction, exportTraderDiariesAction, getTraderDiariesAction, updateTraderDiariesDiaryAction, updateTraderDiaryStateToCancle } from '../redux/actions/traderDiaryActions'
import { createTraderDiaryMassRequest, exportTreaderDiaryRequest, getTraderDiariesRequest, updateOrderDiaryRequest, updateTraderDiaryStateRequest } from '../api/traderDiaryApi'
import { finishLoading, startLoading } from '../redux/actions/loadingActions'
import { closeDialog, openDialog } from '../redux/actions/dialogActions'
import { lookup } from 'mime-types'
import { ACTION_FAILED_ALERT_ID, TRADER_DIARY_INPUT_DIALOG_ID } from '../constants/dialogConstants'
import { TraderDiary } from '../redux/reducers/traderDiary'

export const useTraderDiaryApi = () => {
  const dispatch = useDispatch()

  const getTraderDiaries = useCallback(async (dateFrom: string, dateTo: string) => {
    await getTraderDiariesRequest(dateFrom, dateTo)
      .then(response => {
        dispatch(getTraderDiariesAction(response.data))
      })
      .catch(error => {
        console.error(error)
      })
  }, [])

  const updateOrderDiary = useCallback(async (traderDiaryId: number, diaryValue: boolean) => {
    await updateOrderDiaryRequest(traderDiaryId, diaryValue)
    .then(response => {
      dispatch(updateTraderDiariesDiaryAction(traderDiaryId, diaryValue))
    })
    .catch(error => {
      console.error(error)
    })
  }, [])

  const createTraderDiaryMass = useCallback(async (massTraderDiary: TraderDiary[]) => {
    await createTraderDiaryMassRequest(massTraderDiary)
    .then(response => {
      dispatch(createMassTraderDiariesAction(response.data))
      dispatch(closeDialog(TRADER_DIARY_INPUT_DIALOG_ID))
    })
    .catch(error => {
      console.error(error)
    })
  }, [])

  const updateStateDiaryToCancel = useCallback(async (traderDiaryId: number) => {
    await updateTraderDiaryStateRequest(traderDiaryId)
    .then(response => {
      dispatch(updateTraderDiaryStateToCancle(traderDiaryId))
    })
    .catch(error => {
      console.error(error)
    })
  }, [])

  const exportTraderDiary = useCallback(async (ids: number[], dateFrom: string, dateTo: string) => {
    dispatch(startLoading('exportFile'))
    await exportTreaderDiaryRequest(ids, dateFrom, dateTo)
      .then(async response => {
        dispatch(exportTraderDiariesAction(ids));
        dispatch(finishLoading('exportFile'))
        const link = document.createElement('a')
        const type = lookup(response.data.name)
        console.warn(type)
        link.href = `data:${type};base64,${response.data.content}`
        link.download = response.data.name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
      .catch(error => {
        dispatch(finishLoading('exportFile'))
        dispatch(openDialog(ACTION_FAILED_ALERT_ID))
        console.log(error)
      })
  }, [])


  return {
    getTraderDiaries, updateOrderDiary, exportTraderDiary, createTraderDiaryMass, updateStateDiaryToCancel
  }

}
